import Axios from "../utils/request";

// 资料填写 身份证反面上传完后直接ocr
export const ocrCheck = data =>
    Axios({
        url: "/app/user/attestation/ocrCheck",
        method: "post",
        data
    });

// 资料填写 身份信息 回显
export const echo = (params) =>
    Axios({
        url: "/app/user/attestation/echo",
        params,
        method: "get"
    });

// 资料填写身份认证回显 基础信息回显
export const queryUserBase = data =>
    Axios({
        url: "/user/queryUserBase",
        method: "post",
        data
    });
    
// 资料填写身份认证图片
export const queryuserMedia = data =>
Axios({
    url: "/user/queryuserMedia",
    method: "post",
    data
});

// 资料填写身份认证信息提交
export const userBaseInfoPre = data =>
Axios({
    url: "/tw/user/userBaseInfoPre",
    method: "post",
    data
});

// 资料填写基础信息提交
export const userBase = data =>
    Axios({
        url: "/tw/user/userBase",
        method: "post",
        data
    });

    
// 资料填写工作信息回显
export const queryUserwork = data =>
Axios({
    url: "/tw/user/queryUserwork",
    method: "post",
    data
});
// 资料填写工作信息提交
export const userWork = data =>
Axios({
    url: "/tw/user/userWork",
    method: "post",
    data
});

// 资料填写其他信息回显
export const queryUserContact = data =>
Axios({
    url: "/tw/user/queryUserContact",
    method: "post",
    data
});
// 资料填写其他信息提交
export const userContact = data =>
Axios({
    url: "/tw/user/userContact",
    method: "post",
    data
});
// 用户银行卡列表
export const queryCardList = data =>
    Axios({
        url: "/user/queryCardList",
        method: "post",
        data
    });
// 设置默认银行卡
export const setDefault = data =>
    Axios({
        url: "/user/setDefault",
        method: "post",
        data
    });
// 提交用户银行卡信息
export const userCard = data =>
    Axios({
        url: "/user/userCard",
        method: "post",
        data
    });

// 地区查询
export const queryRegion = data =>
    Axios({
        url: "/query/queryRegion",
        method: "post",
        data
    });
// 枚举
export const userDict = data =>
    Axios({
        url: "/user/dict",
        method: "post",
        data
    });
// 合同具体信息
export const loanInformation = data =>
    Axios({
        url: "/loan/application/loan-information",
        method: "post",
        data
    });